import React from "react";
import styled from "@emotion/styled";
import Accordion from "./ui/Accordion";

export default function FAQs() {
  const faqItems = [
    {
      title: "How does Paartner work?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    },
    {
      title: "How are vendors selected?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum.",
    },
    {
      title: "What makes a good referral?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.",
    },
    {
      title: "What is a Fixed Referral Reward?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    },
    {
      title: "Is there a limit to how much money I can earn?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit.",
    },
    {
      title: "Do I get paid in cash?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.",
    },
    {
      title: "Can I recommend a vendor?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.",
    },
    {
      title: "Is there a limit to the number of referrals I can make?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Ut enim ad minim veniam.",
    },
    {
      title: "I live outside the UK, can I use Paartner?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor.",
    },
    {
      title: "How long does it take to get paid?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat.",
    },
  ];

  // Split items into two columns for desktop view
  const halfLength = Math.ceil(faqItems.length / 2);
  const leftColumnItems = faqItems.slice(0, halfLength);
  const rightColumnItems = faqItems.slice(halfLength);

  return (
    <div>
      <DeviceDefault>
        <Column>
          <Accordion items={leftColumnItems} />
        </Column>
        <Column>
          <Accordion items={rightColumnItems} />
        </Column>
      </DeviceDefault>
      <DeviceMobile>
        <Accordion items={faqItems} />
      </DeviceMobile>
    </div>
  );
}

const DeviceDefault = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 24px;
  padding: 24px;
  width: 1200px;
  margin: 16px;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    width: calc(100% - 32px);
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const DeviceMobile = styled.div`
  display: none;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 24px;
  padding: 24px;
  margin: 16px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    display: block;
    width: calc(100% - 32px);
  }
`;

const Column = styled.div`
  flex: 1;
  min-width: 0; // Prevents flex items from overflowing
`;
